import React, { useEffect, useState } from 'react';
import { CloudDownload, CheckCircle2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { saveApiaryOffline, getSavedApiaries, SAVED_EVENT } from '../../utils/offlineStore';

export const SaveApiaryOfflineButton = ({ yard, hives }) => {
  const [saved, setSaved] = useState(() => getSavedApiaries()[yard.name]);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    const update = () => setSaved(getSavedApiaries()[yard.name]);
    window.addEventListener(SAVED_EVENT, update);
    return () => window.removeEventListener(SAVED_EVENT, update);
  }, [yard.name]);

  const handleSave = async (e) => {
    e.stopPropagation();
    if (!hives.length) { toast.info('No hives in this apiary yet'); return; }
    setProgress(0);
    try {
      const res = await saveApiaryOffline(yard.name, hives, (done, total) => setProgress(Math.round((done / total) * 100)));
      setSaved(res);
      toast.success(`${yard.name} saved for offline`, { description: `${res.count} hive page${res.count !== 1 ? 's' : ''} can now be opened with no signal.` });
    } catch {
      toast.error('Needs signal to save for offline');
    } finally {
      setProgress(null);
    }
  };

  const label = progress !== null ? `Saving ${progress}%` : saved ? `Saved ${new Date(saved.at).toLocaleDateString(undefined, { day: 'numeric', month: 'short' })}` : 'Save for offline';
  const Icon = progress !== null ? Loader2 : saved ? CheckCircle2 : CloudDownload;

  return (
    <button
      onClick={handleSave}
      disabled={progress !== null}
      title={saved ? 'Updates automatically on Wi-Fi every few hours. Tap to refresh now' : 'Download hive pages to view with no signal'}
      className={`text-[11px] font-medium flex items-center gap-1 rounded-full px-2 py-1 transition-colors ${saved ? 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100' : 'bg-amber-50 text-amber-700 hover:bg-amber-100'}`}
      data-testid={`save-apiary-offline-${yard.id}`}
    >
      <Icon className={`h-3.5 w-3.5 ${progress !== null ? 'animate-spin' : ''}`} />
      {label}
    </button>
  );
};

export default SaveApiaryOfflineButton;
